module.exports = __webpack_public_path__ + "static/paymentOther-d6e67b4456f18f30e5f12bc90c3c21c2.jpg";